import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { getUsage } from "../api/getUsage";

/** Credit + basic-request usage for the current period. */
export function useUsage() {
  return useQuery({
    queryKey: queryKeys.billing.usage(),
    queryFn: getUsage,
    staleTime: 60_000,
  });
}
